import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';
import FeatureFlagPage from './pages/FeatureFlagPage';

const FeatureFlagsPage = lazy(() => import('./pages/FeatureFlagsPage'));

export const ROUTES = [
    {
        path: '/feature-flags',
        element: (
            <Suspense fallback={<Spinner block />}>
                <FeatureFlagsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/feature-flags/:featureFlagId',
        element: (
            <Suspense fallback={<Spinner block />}>
                <FeatureFlagPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
